import {atom} from 'jotai';
export const authorizationAtom = atom(false);
